import React, { Component } from 'react';
import {
  ModalContainer,
  Button,
  CamRegistrationIcon,
  FavoritesRegistrationIcon,
  ReportsRegistrationIcon,
} from '@surfline/quiver-react';
import CTAHackChecker from '../../utils/CTAHackChecker';
import config from '../../config';

class ForcedRegistrationModal extends Component {
  componentDidMount() {
    document.body.style.position = 'fixed';
    document.body.style.width = '100%';
    const ctaHackConfig = {
      targetClasses: ['quiver-modal-container', 'ReactModal__Body--open'],
      position: 'fixed',
    };

    this.ctaHackChecker = new CTAHackChecker(ctaHackConfig);
    this.ctaHackChecker.observe();
    this.ctaHackChecker.startDOMCheck();
    window.addEventListener('resize', this.resizeListener);
  }

  componentWillUnmount() {
    this.ctaHackChecker.disconnect();
    this.ctaHackChecker.stopDOMCheck();
    window.removeEventListener('resize', this.resizeListener);
  }

  resizeListener = () => {
    this.ctaHackChecker.disconnect();
    this.ctaHackChecker.stopDOMCheck();
    if (this.resizeTimeout) return;

    this.resizeTimeout = setTimeout(() => {
      this.resizeTimeout = null;
      this.ctaHackChecker.observe();
      this.ctaHackChecker.startDOMCheck();
    }, 3000);
  };

  render() {
    return (
      <div>
        <ModalContainer isOpen contentLabel="Surfline Reg Wall" location="regwall">
          <div className="sl-forced-registration-modal__container">
            <div className="sl-forced-registration-modal__container__header">
              <h2 className="sl-forced-registration-modal__container__header__title">
                Create your free account to continue using Surfline
              </h2>
              <p className="sl-forced-registration-modal__container__tip">
                {`Watch live cams, view Reports & Forecasts and quickly access your
                Favorite spots.`}
              </p>
            </div>
            <div className="sl-forced-registration-modal__container__items">
              <div className="sl-forced-registration-modal__container__item">
                <CamRegistrationIcon />
                <div className="sl-forced-registration-modal__container__item__text">
                  <h3>Watch Live Cams</h3>
                  <p>Check the waves and live conditions from Surfline&apos;s 600+ cams.</p>
                </div>
              </div>
              <div className="sl-forced-registration-modal__container__item">
                <ReportsRegistrationIcon />
                <div className="sl-forced-registration-modal__container__item__text">
                  <h3>Access Reports & Forecasts</h3>
                  <p>
                    Get daily reports and forecasts from surfline&apos;s trusted team of
                    meteorologists.
                  </p>
                </div>
              </div>
              <div className="sl-forced-registration-modal__container__item">
                <FavoritesRegistrationIcon />
                <div className="sl-forced-registration-modal__container__item__text">
                  <h3>Favorite your Spots</h3>
                  <p>Quickly access your Favorite spots from any device.</p>
                </div>
              </div>
            </div>
            <div className="sl-forced-registration-modal__container__options">
              <Button
                onClick={() => window.location.assign(`${config.surflineHost}/create-account`)}
                parentWidth
              >
                Create Account
              </Button>
            </div>
            <p className="sl-forced-registration-modal__container__signin">
              Already registered?
              <a href={`${config.surflineHost}/sign-in?redirectUrl=${window.location}`}>Sign In</a>
            </p>
            <p className="sl-forced-registration-modal__container__homepage">
              <a href={`${config.surflineHost}`}>Return to Homepage</a>
            </p>
          </div>
        </ModalContainer>
      </div>
    );
  }
}

export default ForcedRegistrationModal;
